import createTableStore from "ds/components/Table/store/useTableStore";

import { SPACE_POLICIES_COLUMN_CONFIG, SPACE_POLICIES_COLUMNS_STORAGE_KEY } from "./constants";

const useSpaceDetailsPoliciesTableStore = createTableStore({
  storageKey: SPACE_POLICIES_COLUMNS_STORAGE_KEY,
  config: SPACE_POLICIES_COLUMN_CONFIG,
});

export default useSpaceDetailsPoliciesTableStore;
